import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: () => import('./../components/Home.vue'),
      default: true,
      children: [
        {
          name: 'aberturaempresas',
          path: '/offshore/aberturaempresas',
          component: () => import('./../components/aberturaempresas/index.vue'),
          scaffold: true
        },
        {
          name: 'aberturaempresasedit',
          path: '/offshore/aberturaempresas/edit',
          component: () => import('./../components/aberturaempresas/edit.vue'),
          props: true
        },
        {
          name: 'aberturaempresasadd',
          path: '/offshore/aberturaempresas/add',
          component: () => import('./../components/aberturaempresas/edit.vue')
        },
        {
          name: 'parametro',
          path: '/parametro',
          component: () => import('./../components/parametros/index.vue')
        },
        {
          name: 'parametroedit',
          path: '/parametro/edit',
          component: () => import('./../components/parametros/edit.vue'),
          props: true
        },
        {
          name: 'parametroadd',
          path: '/parametro/add',
          component: () => import('./../components/parametros/edit.vue')
        },
        {
          name: 'usuarios',
          path: '/offshore/usuarios',
          component: () => import('./../components/usuarios/index.vue'),
          scaffold: true
        },
        {
          name: 'usuariosedit',
          path: '/offshore/usuarios/edit',
          component: () => import('./../components/usuarios/edit.vue'),
          props: true
        },
        {
          name: 'usuariosadd',
          path: '/offshore/usuarios/add',
          component: () => import('./../components/usuarios/edit.vue')
        },
        {
          name: 'contato',
          path: '/contato',
          component: () => import('./../components/Contato.vue')
          // default: true
        },
        {
          name: 'empresas',
          path: '/offshore/empresas',
          component: () => import('./../components/empresas/index.vue'),
          scaffold: true
        },
        {
          name: 'empresasedit',
          path: '/offshore/empresas/edit',
          component: () => import('./../components/empresas/edit.vue'),
          props: true
        },
        {
          name: 'empresasadd',
          path: '/offshore/empresas/add',
          component: () => import('./../components/empresas/edit.vue')
        },
        {
          name: 'convites',
          path: '/offshore/convites',
          component: () => import('./../components/convites/index.vue'),
          scaffold: true
        },
        {
          name: 'convitesedit',
          path: '/offshore/convites/edit',
          component: () => import('./../components/convites/edit.vue'),
          props: true
        },
        {
          name: 'convitesadd',
          path: '/offshore/convites/add',
          component: () => import('./../components/convites/edit.vue')
        },
        {
          name: 'gruposusuarios',
          path: '/offshore/gruposusuarios',
          component: () => import('./../components/gruposusuarios/index.vue'),
          scaffold: true
        },
        {
          name: 'gruposusuariosedit',
          path: '/offshore/gruposusuarios/edit',
          component: () => import('./../components/gruposusuarios/edit.vue'),
          props: true
        },
        {
          name: 'gruposusuariosadd',
          path: '/offshore/gruposusuarios/add',
          component: () => import('./../components/gruposusuarios/edit.vue')
        },
        {
          name: 'termosuso',
          path: '/offshore/termosuso',
          component: () => import('./../components/termosuso/index.vue'),
          scaffold: true
        },
        {
          name: 'termosusoedit',
          path: '/offshore/termosuso/edit',
          component: () => import('./../components/termosuso/edit.vue'),
          props: true
        },
        {
          name: 'termosusoadd',
          path: '/offshore/termosuso/add',
          component: () => import('./../components/termosuso/edit.vue')
        },
        {
          name: 'perfil',
          path: '/perfil',
          component: () => import('./../components/Perfil.vue')
        }
      ]
    },
    {
      name: 'redefinir-senha',
      path: '/redefinir-senha',
      component: () => import('./../components/ForgotPassword.vue')
    },
    {
      name: 'recover-password',
      path: '/recuperar-senha',
      component: () => import('./../components/RecoverPassword.vue')
    },
    {
      name: 'login',
      path: '/login',
      component: () => import('./../components/Login.vue')
    },
    {
      name: 'logout',
      path: '/logout',
      component: () => import('./../components/Logout.vue')
    },
    {
      name: 'join',
      path: '/join/:codigo',
      component: () => import('./../components/Join.vue')
    }
  ]
})

const user = JSON.parse(localStorage.getItem('user'))
const telas = user ? user.telas : []
const telasPermitidas = [
  '/login', '/logout', '/recuperar-senha', '/redefinir-senha', '/contato', '/perfil',
  '/parametro', '/parametro/add', '/parametro/edit'
]

router.beforeEach((to, from, next) => {
  let toPath = to.path.replace('/edit', '').replace('/add', '')
  if (!user || !user.codigo || !(telas.find(p => p.path.indexOf(toPath) !== -1))) {
    if (telasPermitidas.find(p => p === to.path)) {
      next()
    } else if (to.name === 'join' && to.path.includes('/join/')) {
      next()
    } else next('/login')
  } else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js